import { WALKTHROUGH_STATUS } from '../../../shared/constants'
import { Profile, User } from '../../../shared/model/models'
import { userActions } from '../../reducers/user'
import { AppDispatch } from '../../store'

export const loginUser =
  (token: string, refreshToken: string, company: string, account: User) => (dispatch: AppDispatch) => {
    dispatch(
      userActions.login({
        token,
        refreshToken,
        company,
        account,
        isAuthenticated: true,
      }),
    )
  }

export const logoutUser = () => (dispatch: AppDispatch) => {
  dispatch(userActions.logout())
}

export const setAuthTokens = (token: string, refreshToken: string) => (dispatch: AppDispatch) => {
  dispatch(userActions.setAuthTokens({ token, refreshToken }))
}

export const changeCurrentTheme = (theme: 'light' | 'dark') => (dispatch: AppDispatch) => {
  dispatch(userActions.setCurrentTheme(theme))
}

export const changeCurrentLanguage = (lang: 'de' | 'en') => (dispatch: AppDispatch) => {
  dispatch(userActions.setCurrentLanguage(lang))
}

export const changeWalkthroughStatus = (status: WALKTHROUGH_STATUS) => (dispatch: AppDispatch) => {
  dispatch(userActions.setWalkthroughStatus(status))
}

export const changeWalkthroughIndex = (index: number) => (dispatch: AppDispatch) => {
  dispatch(userActions.setWalkthroughIndex(index))
}

export const startWalkthrough = () => (dispatch: AppDispatch) => {
  dispatch(userActions.startWalkthrough())
}

export const changeWalkthroughVideo = (show: boolean) => (dispatch: AppDispatch) => {
  dispatch(userActions.setWalkthroughVideo(show))
}

export const updateProfileState = (profile: Profile) => (dispatch: AppDispatch) => {
  dispatch(userActions.updateProfileState(profile))
}

export const askForAccess = (appName: string) => (dispatch: AppDispatch) => {
  dispatch(userActions.setAskAccess(appName))
}

export const removeAccessReq = () => (dispatch: AppDispatch) => {
  dispatch(userActions.setAskAccess(null))
}

export const setHtmlFontSize = (htmlFontSize: number) => (dispatch: AppDispatch) => {
  dispatch(userActions.setHtmlFontSize(htmlFontSize))
}

export const clearLastKnownLocation = () => (dispatch: AppDispatch) => {
  dispatch(userActions.clearLastKnownLocation())
}

export * from './thunk'
